export interface StatementUploadAccount {
    is_quiltt: boolean;
    account_mask: string;
    quiltt_account_id: string | null;
    plaid_institution_id?: string;
    reason?: string;
    year?: number;
    month?: number;
}

export interface StatementUploadTaskContext {
    year: number;
    month: number;
    accounts: StatementUploadAccount[];
    institution_name: string;
}

/**
 * Derives a single reason for an institution row from its accounts.
 * Returns the first reason string found, or undefined if none.
 */
export function getInstitutionReason(accounts: StatementUploadAccount[]): string | undefined {
    return accounts.find((a) => a.reason)?.reason;
}
